// SINGLE SOURCE OF TRUTH for the campaign delivery-status colours.
//
// Consumed by every progress surface so they read as one system:
//   - the campaign step meter (sequence-detail.tsx: bar segments + per-message breakdown)
//   - the delivery-logs status filter tiles (campaign-message-log-status-filter.tsx)
//   - the per-row status badges (MessageLogStatusBadge.tsx)
//   - the top-bar progress badge (in-progress-campaign-indicator.tsx)
//
// Keys map 1:1 to the computeCampaignProgress buckets:
//   sent = LIGHT green (single ✓) · delivered = green (✓✓) · read = blue (double blue ✓✓) ·
//   interacted = purple · failed = red.
// Change a colour HERE and it updates everywhere.
export const CAMPAIGN_STATUS_COLORS = {
    sending: '#4ade80',    // green-400   — sent (LIGHT green)
    delivered: '#10b981',  // emerald-500 — delivered (✓✓)
    read: '#3b82f6',       // blue-500    — read (double BLUE ✓✓)
    interacted: '#a855f7', // purple-500  — played / interacted
    failed: '#ef4444',     // red-500     — failed / expired
} as const;

export type CampaignStatusColorKey = keyof typeof CAMPAIGN_STATUS_COLORS;

/** Slate for the pre-wire "Queued" badge — not a delivery bucket, kept alongside. */
export const CAMPAIGN_STATUS_QUEUED_COLOR = '#64748b'; // slate-500
